<template>
  <div>
    <img class="logo" src="https://beneflex-icons.s3.amazonaws.com/clients/logo1.svg" />
    <v-navigation-drawer class="sidebar" v-model="drawer" mini-variant permanent>
      <v-list class="my-10">
        <template>
          <div>
            <v-list-item v-for="item in visibleItems" :key="item.title" :to="item.link" @click="handleItemClick(item)">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </v-list-item>
            <v-list-item v-if="showMoreFunctionality" @click="openSheet">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-dots-horizontal</v-icon>
                  </v-list-item-icon>
                </template>
                <span>Ver más funcionalidades</span>
              </v-tooltip>
            </v-list-item>
          </div>
        </template>
      </v-list>
      <v-list class="mt-8">
        <v-list-item class="mt-1" color="primary"  @click="salir">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon color="primary">mdi-logout</v-icon>
              </v-list-item-icon>
            </template>
            <span>Salir</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-menu v-model="sheet" :nudge-right="58" ref="menu" :position-x="menuPosition.x" :position-y="menuPosition.y">
      <v-card style="height: 420px; width: 400px; overflow-y: auto;">
        <v-card-text>
          <v-text-field v-model="searchQuery" label="Buscar funcionalidad" outlined dense @click.stop>
            <template v-slot:append>
              <v-icon>mdi-magnify</v-icon>
            </template>
          </v-text-field>
          <div class="row">
            <div class="col-4 col-md-4 d-flex flex-column align-items-center" v-for="item in filteredItemSubmenu"
              :key="item.title">
              <v-btn outlined block :href="item.link"
                class="d-flex align-items-center justify-content-center no-outline" style="max-width: 100px;">
                <v-icon color="#6E17A5" size="28">{{ item.icon }}</v-icon>
              </v-btn>
              <span class="mt-1 text-center" style="width: 100%;">{{ item.title }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import router from "@/router/index";
export default {
  name: "sidebar",
  data() {
    return {
      drawer: true,
      empresa: sessionStorage.getItem("empresa"),
      menuPosition: { x: 0, y: 0 },
      searchQuery: '',
      sheet: false,
      allowedScreens: [],
      role: sessionStorage.getItem('roleId'),
      items: [
        { title: "Inicio", icon: "mdi-home-outline", link: "/home", screen: "home" },
        { title: "Categorías Marketplace", icon: "mdi-store-outline", link: "/marketplace", screen: "marketplace" },
        { title: "Categorías Pizarra", icon: "mdi-domain", link: "/board", screen: "board" },
        { title: "Productos", icon: "mdi-cart-outline", link: "/product", screen: "product" },
        { title: "Empresas", icon: "mdi-factory", link: "/companies", screen: "companies" },
        { title: "Usuarios", icon: "mdi-account-cog-outline", link: "/users_admin", screen: "users_admin" },
        { title: "Reconocimiento", icon: "mdi-folder-star-outline", link: "/buy_recognition", screen: "buy_recognition" },
        { title: "Proveedores", icon: "mdi-briefcase-check-outline", link: "/suppliers", screen: "suppliers" },
        { title: "Conciliación", icon: "mdi-briefcase-check-outline", link: "/purchase_reconciliation", screen: "purchase_reconciliation" },
        { title: "Asignación", icon: "mdi-account-star-outline", link: "/shape_assignment", screen: "shape_assignment" },
      ],
      itemSubmenu: [],
    };
  },
  
  computed: {
    visibleItems() {
      return this.items.slice(0, 5);
    },
    showMoreFunctionality() {
    return this.itemSubmenu.length > 0;
  },
  filteredItemSubmenu() {
    return this.itemSubmenu.filter(item =>
      item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
   },
  },

  created() {
    this.loadAllowedScreens();
  },

  methods: {
    loadAllowedScreens() {
      const screens = JSON.parse(sessionStorage.getItem('allowedScreens')) || [];
      this.allowedScreens = Array.isArray(screens) ? screens : [];
      this.updateMenuItems();
    },

    updateMenuItems() {
      const allowedScreenKeys = this.allowedScreens;
    
      this.items = [
        { title: "Inicio", icon: "mdi-home-outline", link: "/home", screen: "home" },
        { title: "Categorías Marketplace", icon: "mdi-store-outline", link: "/marketplace", screen: "marketplace" },
        { title: "Categorías Pizarra", icon: "mdi-domain", link: "/board", screen: "board" },
        { title: "Productos", icon: "mdi-cart-outline", link: "/product", screen: "product" },
        { title: "Empresas", icon: "mdi-factory", link: "/companies", screen: "companies" },
        { title: "Usuarios", icon: "mdi-account-cog-outline", link: "/users_admin", screen: "users_admin" },
        { title: "Reconocimiento", icon: "mdi-folder-star-outline", link: "/buy_recognition", screen: "buy_recognition" },
        { title: "Proveedores", icon: "mdi-briefcase-check-outline", link: "/suppliers", screen: "suppliers" },
        { title: "Conciliación", icon: "mdi-checkbox-marked-circle-outline", link: "/purchase_reconciliation", screen: "purchase_reconciliation" },
        { title: "Asignación", icon: "mdi-account-star-outline", link: "/shape_assignment", screen: "shape_assignment" },
      ].filter(item => allowedScreenKeys.includes(item.screen));

      this.itemSubmenu = this.items.slice(5);
      this.items = this.items.slice(0, 5);
    },

    showListCompanies(itemTitle) {
      let empresa = sessionStorage.getItem("empresa").toLowerCase();
      empresa = empresa ? empresa.replace(/"/g, "").toLowerCase() : "";
      const menu = "Empresas";
      const luca = 'lucasian';

      // Verifica si lucasian es igual a 'lucasian' y si itemTitle no es 'Empresas'
      if (empresa === luca || itemTitle.toLowerCase() !== menu.toLowerCase()) {
        return true; // Muestra el elemento
      } else {
        return false; // No muestra el elemento si son iguales
      }
    },
    salir() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('idGroup');
      sessionStorage.removeItem('idUsuario');
      sessionStorage.removeItem('idEmpresa');
      router.push({ path: '/login' })
    },

    handleItemClick(item) {
      if (item.customAction === "openSheet") {
        this.openSheet();
      }
    },
    openSheet() {
      this.sheet = true;
      this.menuPosition.x = this.$refs.menu.$el.clientWidth
      this.menuPosition.y = event.clientY;
    },
    closeSheet() {
      this.sheet = false;
    }
  }
};
</script>

<style lang="css" scoped>
img {
  position: fixed;
  margin: 30px 0px 0px 0px;
  width: 4em;
}

.sidebar {
  top: 6rem !important;
  position: fixed;
  border-top-right-radius: 175px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.no-outline {
  border: none !important;
  outline: none !important;
}

.v-list-item__icon {
  margin-left: 0 !important;
}
</style>
